import { useLanguage } from "@/i18n/LanguageContext";

const repairs = [
  {
    title: "Roller Replacement",
    description: "Sliding door rollers worn from salt air. Stainless replacements.",
    icon: "ri-wheelchair-line",
  },
  {
    title: "Lock & Latch Repair",
    description: "Window locks, sliding door locks. Re-key or replace.",
    icon: "ri-lock-unlock-line",
  },
  {
    title: "Handle Replacement",
    description: "Broken handles on sliders, casements, awnings.",
    icon: "ri-hand-coin-line",
  },
  {
    title: "Hinge Repair",
    description: "Casement and awning hinges. Corroded hinge replacement.",
    icon: "ri-settings-3-line",
  },
  {
    title: "Crank Operator",
    description: "Casement window cranks. Stripped operators fixed.",
    icon: "ri-refresh-line",
  },
  {
    title: "Track Cleaning",
    description: "Sliding door tracks. Cleaning, lubrication, alignment.",
    icon: "ri-menu-4-line",
  },
];

export default function WhatWeRepair() {
  const { t } = useLanguage();

  return (
    <section className="w-full bg-white py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-black text-secondary mb-4">
            {t("hardware.servicesH2")}
          </h2>
          <p className="text-sm md:text-base text-[#374151] max-w-[720px] mx-auto">
            Affordable repair on working parts of existing windows. No installation, no permits, no contractor markup.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {repairs.map((r) => (
            <div
              key={r.title}
              className="bg-white rounded-xl border-t-4 border-primary p-6 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-lg mb-4">
                <i className={`${r.icon} text-2xl text-primary`} />
              </div>
              <h3 className="text-xl font-bold text-secondary mb-2">
                {r.title}
              </h3>
              <p className="text-sm text-[#374151] leading-relaxed">
                {r.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}